import {
    Platform
} from "react-native";
import type {
    PopoverSurfaceAnchorMeasureConstantType
} from "./type";

export const POPOVER_SURFACE_FORWARDED_KEY = "Escape";

export const POPOVER_SURFACE_EDITABLE_TAG_NAMES: Array<string> = [
    "TEXTAREA",
    "SELECT",
    "INPUT"
];

export const getPopoverSurfaceElement = (node: unknown) => {
    if(typeof HTMLElement === "undefined" || !(node instanceof HTMLElement)) {
        return null;
    }

    return node;
};

export const getIsPopoverSurfaceEditable = (target: EventTarget | null) => {
    const element = getPopoverSurfaceElement(target);

    if(!element) {
        return false;
    }

    return element.isContentEditable || POPOVER_SURFACE_EDITABLE_TAG_NAMES.includes(element.tagName);
};

export const measurePopoverSurfaceAnchor = ({
    onMeasure,
    anchorRef
}: PopoverSurfaceAnchorMeasureConstantType) => {
    const anchor = anchorRef.current;

    if(!anchor) {
        return;
    }

    if(Platform.OS === "web" && typeof anchor.getBoundingClientRect === "function") {
        onMeasure(anchor.getBoundingClientRect().width);

        return;
    }

    anchor.measureInWindow((_x, _y, anchorWidth) => {
        onMeasure(anchorWidth);
    });
};
